import React from 'react';
import ConfirmDialog from '@/components/ui/ConfirmDialog';
import { useConfirmStore } from '@/hooks/useConfirm';

export const ConfirmDialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isOpen, title, message, confirmText, cancelText, type, confirm, cancel } = useConfirmStore();

  return (
    <>
      {children}
      <ConfirmDialog
        isOpen={isOpen}
        onClose={cancel}
        onConfirm={confirm}
        title={title}
        message={message}
        confirmText={confirmText}
        cancelText={cancelText}
        type={type}
      />
    </>
  );
};
